var firebaseConfig = {
    apiKey: "AIzaSyB8q-XX5_EsjcnyurpPQXvkmVAjYxau4pQ",
    authDomain: "hot-onion-3b072.firebaseapp.com",
    projectId: "hot-onion-3b072",
    storageBucket: "hot-onion-3b072.appspot.com",
    messagingSenderId: "155053242303",
    appId: "1:155053242303:web:5b106c0197998f7cc4530a"
  };
  // Initialize Firebase
  export default firebaseConfig;